import React, { CSSProperties } from 'react';

interface TextProps {
    x?: number;
    y?: number;
    style?: CSSProperties;
}
const Text: React.FC<TextProps> = props => {
    const str = React.Children.toArray(props.children).filter(o => o).join('');
    const strArray = str?.split('\n');

    return <text x={props.x} y={props.y ? props.y - 20 : undefined} style={props.style}
    >
        {strArray?.map((o, idx) => {
            return <tspan key={idx} x={props.x} dy={20}>{o && o.trim()}</tspan>
        })}
    </text>
}

export default Text